import { ANY_SPORT_MY_CLUB } from '#src/constants/__generated__/routes.ts';
import {
  SHARED_PRO_SET_PAGES,
  isSharedProSetPath,
} from '#src/lib/routing/generateSportPath.ts';

import { useEnableArcadeManagerProfile } from './useEnableArcadeManagerProfile.ts';

export const useIsSharedProSetPath = () => {
  const enableArcadeManagerProfile = useEnableArcadeManagerProfile();

  // Once Set has its own manager profile, /my-club is the Pro half of a pair
  // rather than one page both products share.
  const sharedPages = enableArcadeManagerProfile
    ? SHARED_PRO_SET_PAGES.filter(path => path !== ANY_SPORT_MY_CLUB)
    : SHARED_PRO_SET_PAGES;

  return (pathname: string) => isSharedProSetPath(pathname, sharedPages);
};
